export const baseUrl = 'https://admin.dentfinder.io/api/';
